/*
 * @Author: your name
 * @Date: 2020-12-29 17:24:32
 * @LastEditTime: 2021-05-07 15:19:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /pub-app-new/src/module/coupon/router/index.js
 */
const couponList = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('@/module/coupon/coupon-list'));
    },
    'coupon-list'
  );
};
const couponExchange = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('@/module/coupon/coupon-exchange'));
    },
    'coupon-exchange'
  );
};
const couponSelect = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('@/module/coupon/coupon-select'));
    },
    'coupon-select'
  );
};
const newCouponSelect = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('@/module/coupon/new-coupon-select'));
    },
    'new-coupon-select'
  );
};
const couponInvalid = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('@/module/coupon/coupon-invalid'));
    },
    'coupon-invalid'
  );
};
const couponQa = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('@/module/coupon/coupon-qa'));
    },
    'coupon-qa'
  );
};
const couponLogin = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('@/module/coupon/coupon-login'));
    },
    'coupon-login'
  );
};
export default [
  {
    name: 'coupon-list',
    path: '/coupon/list',
    component: couponList,
    meta: { title: '优惠券' }
  },
  {
    name: 'coupon-exchange',
    path: '/coupon/exchange',
    component: couponExchange,
    meta: { title: '兑换券码' }
  },
  {
    name: 'coupon-select',
    path: '/coupon/select',
    component: couponSelect,
    meta: { title: '选择券' }
  },
  {
    name: 'new-coupon-select',
    path: '/new/coupon/select',
    component: newCouponSelect,
    meta: { title: '选择券' }
  },
  {
    name: 'coupon-invalid',
    path: '/coupon/invalid',
    component: couponInvalid,
    meta: { title: '历史优惠券' }
  },
  {
    name: 'coupon-qa',
    path: '/coupon/qa',
    component: couponQa,
    meta: { title: '使用说明' }
  },
  {
    name: 'coupon-login',
    path: '/coupon/login',
    component: couponLogin,
    meta: { title: '优惠券' }
  }
];
